import { render, staticRenderFns } from "./RestaurantPricingDialog.vue?vue&type=template&id=c6293edc&scoped=true"
import script from "./RestaurantPricingDialog.vue?vue&type=script&lang=js"
export * from "./RestaurantPricingDialog.vue?vue&type=script&lang=js"
import style0 from "./RestaurantPricingDialog.vue?vue&type=style&index=0&id=c6293edc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6293edc",
  null
  
)

export default component.exports